import React, { useContext, useEffect, useRef, useState } from "react";

import { useNavigate, useParams } from "react-router-dom";
import { MENU_PRODUCTS } from "../../constants/products";
import { BottomSheet } from "react-spring-bottom-sheet";
import { currency } from "../../utils";
import LogoPeach from "../../assets/images/logo/adb.png";

import "./styles.scss";
import { getAnalytics, logEvent } from "firebase/analytics";
import { CartContext } from "../../context/cartContext";
import * as SwipeDown from "../../assets/lottie/swipe-down.json";
import Lottie from "react-lottie";

const BackButton = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="42"
    height="42"
    fill="none"
    viewBox="0 0 42 42"
    {...props}
  >
    <g filter="url(#filter0_d_0_1)">
      <rect width="32" height="32" x="5" y="4" fill="#fff" rx="8"></rect>
    </g>
    <path
      fill="#000"
      d="M19.764 20.003L25 14.765a.76.76 0 00.224-.541.76.76 0 00-.224-.542l-.459-.458a.76.76 0 00-.541-.224.76.76 0 00-.542.224l-6.236 6.236a.76.76 0 00-.223.543c0 .206.078.399.223.544l6.23 6.23a.76.76 0 00.542.223.76.76 0 00.542-.224l.458-.459a.767.767 0 000-1.082l-5.231-5.232z"
    ></path>
    <defs>
      <filter
        id="filter0_d_0_1"
        width="42"
        height="42"
        x="0"
        y="0"
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        ></feColorMatrix>
        <feOffset dy="1"></feOffset>
        <feGaussianBlur stdDeviation="2.5"></feGaussianBlur>
        <feComposite in2="hardAlpha" operator="out"></feComposite>
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"></feColorMatrix>
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_0_1"
        ></feBlend>
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_0_1"
          result="shape"
        ></feBlend>
      </filter>
    </defs>
  </svg>
);

function CartIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="42"
      height="42"
      fill="none"
      viewBox="0 0 42 42"
      {...props}
    >
      <g filter="url(#filter0_d_113_95)">
        <rect width="32" height="32" x="5" y="4" fill="#fff" rx="8"></rect>
      </g>
      <path
        fillRule="evenodd"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M14.015 17.638l.375 5.385c.13 2.217 1.824 3.95 3.885 3.977h5.449c2.062-.026 3.756-1.76 3.886-3.977l.375-5.385a4.477 4.477 0 00-1.005-3.232c-.738-.88-1.782-1.39-2.882-1.406H17.9c-1.1.017-2.144.527-2.881 1.406a4.478 4.478 0 00-1.005 3.232z"
        clipRule="evenodd"
      ></path>
      <path
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M23.998 17.308c0 1.154-.572 2.22-1.5 2.798a2.813 2.813 0 01-2.998 0c-.927-.577-1.499-1.644-1.499-2.798"
      ></path>
      <defs>
        <filter
          id="filter0_d_113_95"
          width="42"
          height="42"
          x="0"
          y="0"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          ></feColorMatrix>
          <feOffset dy="1"></feOffset>
          <feGaussianBlur stdDeviation="2.5"></feGaussianBlur>
          <feComposite in2="hardAlpha" operator="out"></feComposite>
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"></feColorMatrix>
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_113_95"
          ></feBlend>
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_113_95"
            result="shape"
          ></feBlend>
        </filter>
      </defs>
    </svg>
  );
}

const ProductDetails = () => {
  const params = useParams();
  const navigate = useNavigate();
  const { addProduct, getTotalQuantity } = useContext(CartContext);

  const [productInfo, setProductInfo] = useState(undefined);
  const [swipeDownShow, setSwipeDownShow] = useState(true);

  const focusRef = useRef();
  const sheetRef = useRef();

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: SwipeDown,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
      hideOnTransparent: true,
    },
  };

  const findProduct = ({ productId, categoryId }) =>
    MENU_PRODUCTS.find((category) => category.id === categoryId).products.find(
      (product) => product.id === Number(productId)
    );

  const goBack = () => (navigate(-1) ? navigate(-1) : navigate("/"));

  const addProductToCart = () => {
    addProduct(productInfo);
    const canVibrate = window.navigator.vibrate;
    if (canVibrate) window.navigator.vibrate(10);
  };

  useEffect(() => {
    setProductInfo(findProduct(params));

    const analytics = getAnalytics();
    logEvent(analytics, "product_details", {
      content_type: findProduct(params).category,
      content_id: findProduct(params).title,
      items: [{ ...findProduct(params) }],
    });

    return () => {
      setProductInfo(undefined);
    };
  }, [params]);

  const handleSwipeDown = (event) => {
    setSwipeDownShow(
      sheetRef.current.height > 100 &&
        (event.source === "dragging" || event.type === "OPEN")
    );
  };

  useEffect(() => {
    setTimeout(() => {
      setSwipeDownShow(false);
    }, 3000);
  }, [swipeDownShow]);

  useEffect(() => {
    var cartIconElement = document.querySelector(
      ".product-details__header__cart"
    );

    // Cria um novo elemento div
    var novoElemento = document.createElement("div");

    // Adiciona conteúdo ao novo elemento
    novoElemento.textContent = String(getTotalQuantity());
    novoElemento.classList.add("product-details__header__cart__qty");

    var elementoExistente = document.querySelector(
      ".product-details__header__cart__qty"
    );

    if (cartIconElement)
      if (elementoExistente) {
        cartIconElement.replaceChild(novoElemento, elementoExistente);
      } else {
        cartIconElement.appendChild(novoElemento);
      }
  }, [getTotalQuantity]);

  if (!productInfo) {
    return (
      <div className="h-full w-full flex items-center justify-center flex-col gap-5">
        <div>
          <img
            style={{ width: 200, height: "100%", objectFit: "cover" }}
            src={LogoPeach}
            alt="Amor De Bia"
          />
        </div>
        <span className="text-peach text-center font-sans font-semibold">
          Carregando produto...
        </span>
      </div>
    );
  }

  return (
    <div className="product-details">
      <div className="product-details__header">
        <BackButton className="adb-touchable" onClick={goBack} />

        <div
          className="product-details__header__cart"
          onClick={() => navigate("/order")}
        >
          {getTotalQuantity() > 0 && (
            <div className="product-details__header__cart__qty">
              {String(getTotalQuantity())}
            </div>
          )}
          <CartIcon className="adb-touchable" />
        </div>
      </div>
      {productInfo && (
        <main style={{ backgroundImage: `url('${productInfo.image}')` }}>
          <BottomSheet
            open
            skipInitialTransition
            ref={sheetRef}
            initialFocusRef={focusRef}
            defaultSnap={({ maxHeight }) => maxHeight / 2}
            snapPoints={({ maxHeight }) => [110, maxHeight / 1.7]}
            expandOnContentDrag
            onSpringStart={handleSwipeDown}
            onSpringEnd={handleSwipeDown}
            scrollLocking
            blocking={false}
            footer={
              <div className="flex items-center justify-center product-details__footer">
                <svg
                  onClick={addProductToCart}
                  className="adb-touchable"
                  xmlns="http://www.w3.org/2000/svg"
                  width="103"
                  height="103"
                  fill="none"
                  viewBox="0 0 103 103"
                >
                  <g filter="url(#filter0_d_113_80)">
                    <circle
                      cx="51.145"
                      cy="48.145"
                      r="41.145"
                      fill="#EE9280"
                    ></circle>
                    <circle
                      cx="51.145"
                      cy="48.145"
                      r="39.145"
                      stroke="#fff"
                      strokeWidth="4"
                    ></circle>
                  </g>
                  <path
                    fill="#fff"
                    d="M51.513 62.005a1.301 1.301 0 01-1.301-1.302v-24.38a1.301 1.301 0 112.603 0v24.38c0 .72-.583 1.302-1.302 1.302zm-12.18-12.18a1.311 1.311 0 110-2.623h24.36a1.311 1.311 0 110 2.623h-24.36z"
                  ></path>
                  <defs>
                    <filter
                      id="filter0_d_113_80"
                      width="102.29"
                      height="102.29"
                      x="0"
                      y="0"
                      colorInterpolationFilters="sRGB"
                      filterUnits="userSpaceOnUse"
                    >
                      <feFlood
                        floodOpacity="0"
                        result="BackgroundImageFix"
                      ></feFlood>
                      <feColorMatrix
                        in="SourceAlpha"
                        result="hardAlpha"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      ></feColorMatrix>
                      <feOffset dy="3"></feOffset>
                      <feGaussianBlur stdDeviation="5"></feGaussianBlur>
                      <feComposite in2="hardAlpha" operator="out"></feComposite>
                      <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"></feColorMatrix>
                      <feBlend
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_113_80"
                      ></feBlend>
                      <feBlend
                        in="SourceGraphic"
                        in2="effect1_dropShadow_113_80"
                        result="shape"
                      ></feBlend>
                    </filter>
                  </defs>
                </svg>
              </div>
            }
            className="product-details__info"
          >
            <div className={`swipe-down${!swipeDownShow ? " fadeOut" : ""}`}>
              <Lottie options={defaultOptions} height={50} width={50} />
            </div>
            <div className="px-5 py-3 flex flex-col">
              <div className="product-details__info__category">
                <span className="font-sans text-peach font-light">
                  {productInfo.category}
                </span>
              </div>
              <h1
                className="font-sans text-peach font-semibold"
                style={{ fontSize: 26 }}
              >
                {productInfo.title}
              </h1>

              <p className="font-sans text-mediumGray font-light">
                {productInfo.description}
              </p>

              <div className="product-details__info__price">
                <span className="font-sans text-black font-bold">
                  {currency.format(productInfo.price)}
                </span>
              </div>
            </div>
          </BottomSheet>
        </main>
      )}
    </div>
  );
};

export default ProductDetails;
